import { render, staticRenderFns } from "./MdImportToSetDialog.vue?vue&type=template&id=2bfc51fc&scoped=true&"
import script from "./MdImportToSetDialog.vue?vue&type=script&lang=js&"
export * from "./MdImportToSetDialog.vue?vue&type=script&lang=js&"
import style0 from "./MdImportToSetDialog.vue?vue&type=style&index=0&id=2bfc51fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc51fc",
  null
  
)

export default component.exports